/**
 * Global signal module for the staging gate wall.
 *
 * StagingGateWall registers a trigger function here on mount.
 * swimminglyApi calls triggerGateWall() when it receives a
 * { error: "staging_gate" } 401 response, causing the wall to
 * appear immediately without waiting for the next poll cycle.
 */

let _trigger: (() => void) | null = null

export function registerGateTrigger(fn: () => void): void {
  _trigger = fn
}

export function unregisterGateTrigger(): void {
  _trigger = null
}

export function triggerGateWall(): void {
  _trigger?.()
}
